import StackAPI from '../../../lib/StackAPI'
import { getUser } from './getUser'

const ENDPOINT = '/api/org_users'

export const updateOrgUserEmail = async (email: string) => {
  const { id } = getUser()
  const { put } = StackAPI()

  const request = {
    path: `${ENDPOINT}/${id}`,
    params: {
      data: {
        id,
        type: 'org_users',
        attributes: {
          email
        }
      }
    },
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }
  }

  return await put(request)
    .then((response) => {
      if (response.status !== 200) {
        return { error: 'bad response' }
      }

      return response.data
    })
    .catch(() => ({ error: 'unknown error' }))
}
